export const EVENT_CHAT_MODE_GROUP_UNIFIED = 'group_unified';

export const resolveEventThreadId = (row = {}) =>
  row?.chat_thread_id ||
  row?.chatThreadId ||
  row?.thread_id ||
  row?.threadId ||
  null;

const hasOwn = (row, key) =>
  !!row && Object.prototype.hasOwnProperty.call(row, key);

export const resolveExplicitEventChatMode = (row = {}) => {
  if (!hasOwn(row, 'chat_mode') && !hasOwn(row, 'chatMode')) return null;
  const value = String(row?.chat_mode ?? row?.chatMode ?? '').trim();
  return value || null;
};

export const resolveEventChatMode = (row = {}) =>
  resolveExplicitEventChatMode(row) || 'separate';

export const resolveExplicitEventGroupCount = (row = {}) => {
  if (!hasOwn(row, 'group_event_count') && !hasOwn(row, 'groupEventCount')) {
    return null;
  }
  const raw = Number(row?.group_event_count ?? row?.groupEventCount);
  if (!Number.isFinite(raw) || raw < 1) return null;
  return Math.floor(raw);
};

export const resolveEventGroupCount = (row = {}) => {
  return resolveExplicitEventGroupCount(row) ?? 1;
};

export const isUnifiedEventGroupChatRow = (row = {}) =>
  resolveEventChatMode(row) === EVENT_CHAT_MODE_GROUP_UNIFIED ||
  resolveEventGroupCount(row) > 1;

export const normalizeEventPerformanceTypeForThread = (row = {}, performanceType = '') => {
  const normalized = String(performanceType ?? '').trim();
  if (!normalized) return '';
  return isUnifiedEventGroupChatRow(row) ? '' : normalized;
};
